// Avertissements d'interopérabilité (n'altèrent JAMAIS la valeur testée).
const INVISIBLE = /[\u200B-\u200F\u2028-\u202E\u2060-\u2064\uFEFF\u00AD]/u;
// eslint-disable-next-line no-control-regex
const CONTROL = /[\u0000-\u001F\u007F-\u009F]/u;

export function unicodeWarnings(pw) {
  if (!pw) return [];
  const w = [];
  if (/^\s|\s$/u.test(pw)) w.push("edgeSpaces");
  if (/\s{2,}/u.test(pw)) w.push("repeatedSpaces");
  if (CONTROL.test(pw)) w.push("control");
  if (INVISIBLE.test(pw)) w.push("invisible");
  if (pw.normalize("NFC") !== pw) w.push("notNfc");
  return w;
}

// Longueur en points de code (emoji = 1), information seulement.
export const codePointLength = (pw) => Array.from(pw || "").length;
